<template>
  <base-card body-class="p-0">
    <template v-slot:header>
      <base-card-heading>
        {{ heading }}
      </base-card-heading>
      <base-button :modal="`#${id}`" secondary small>
        Upload
      </base-button>
    </template>
    <template v-if="documents.length">
      <base-table>
        <colgroup>
          <col width="30%">
          <col width="70%">
        </colgroup>
        <thead>
          <tr>
            <th>Date Added</th>
            <th>Name</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(document, key) in documents"
            :key="key">
            <td>{{ $dates.toDateTime(document.createdAt) }}</td>
            <td>
              <a
                :href="`${base}?bucket=${document.bucket}&uuid=${document.uuid}`"
                target="_blank">
                {{ document.caption ? document.caption : document.name }}
              </a>
            </td>
          </tr>
        </tbody>
      </base-table>
    </template>
    <template v-else>
      <div class="text-center py-4">
        No documents added yet.
      </div>
    </template>
    <add-project-document :id="id" :tag="tag" />
  </base-card>
</template>

<script>
import { mapGetters } from 'vuex'

import AddProjectDocument from './AddProjectDocument.vue'

export default {
  name: 'DocumentSection',

  components: {
    AddProjectDocument
  },

  props: {
    documents: Array,
    heading: String,
    store: String,
    tag: String
  },

  computed: {
    id () {
      return `upload-${this.tag}-modal`
    },

    ...mapGetters({
      base: 'core/storage/base'
    })
  }
}
</script>
